import { protectBusinessRoutes } from './business/permissions';
import accountRoutes from './gateway/accounts';
import apiKeyRoutes from './gateway/api-keys';
import instanceRoutes from './gateway/instances';
import serverRoutes from './gateway/servers';

export default protectBusinessRoutes(
  [serverRoutes, instanceRoutes, accountRoutes, apiKeyRoutes].flat(),
);
